import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { colors } from '@guryou/colors';
import { Block, CheckBox, FlexColumn, Form, LargeText, MailBox, NewsLetterImage, OutlinedButton, PaperBlock } from '@guryou/html-components';
import { useTheme } from '@material-ui/core/styles';

const NewsLetters = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [privacyAgreed, setPrivacyAgreed] = useState(false);

  return (
    <Block
      margin={0}
      xs={12}
      height="550px"
      textAlign="center"
      backgroundImage={`url(${NewsLetterImage})`}
      backgroundRepeat="no-repeat"
      backgroundSize="cover"
      backgroundPosition="center center"
      backgroundAttachment="fixed"
    >
      <section class="h-full flex flex-col items-center justify-center">
        <div class="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6 bg-gray-900 bg-opacity-90 rounded">
          <div class="mx-auto max-w-screen-md sm:text-center">
            <h2 class="mb-4 text-3xl tracking-tight font-extrabold sm:text-4xl text-white">{t('NEWSLETTER.newsletterTitle')}</h2>
            <p class="mx-auto mb-8 max-w-2xl font-light text-gray-500 md:mb-12 sm:text-xl text-gray-400">
              Rimani aggiornato sui progressi delle nostre esperienze wellness, novità esclusive e sconti speciali.
            </p>
            <form action="#">
              <div class="items-center mx-auto mb-3 space-y-4 max-w-screen-sm sm:flex sm:space-y-0">
                <div class="relative w-full">
                  <label for="email" class="hidden mb-2 text-sm font-medium text-gray-300">
                    Email address
                  </label>
                  <div class="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                    <svg class="w-5 h-5 text-gray-500 text-gray-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path>
                      <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path>
                    </svg>
                  </div>
                  <input
                    class="block p-3 pl-10 w-full text-sm bg-gray-50 rounded-lg border border-gray-300 sm:rounded-none sm:rounded-l-lg focus:ring-primary-500 focus:border-primary-500 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-primary-500 focus:border-primary-500"
                    placeholder="Enter your email"
                    type="email"
                    id="email"
                    required=""
                  />
                </div>
                <div>
                  <button
                    type="submit"
                    class="py-3 px-5 w-full text-sm font-medium text-center text-white rounded-lg border cursor-pointer bg-primary-700 border-primary-600 sm:rounded-none sm:rounded-r-lg hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 bg-primary-600 hover:bg-primary-700 focus:ring-primary-800"
                  >
                    Subscribe
                  </button>
                </div>
              </div>
              <div class="mx-auto max-w-screen-sm text-sm text-left text-gray-500 newsletter-form-footer">
                We care about the protection of your data.{' '}
                <a href="#" class={`font-medium text-[${colors.mandy}] hover:underline`}>
                  Read our Privacy Policy
                </a>
                .
              </div>
            </form>
          </div>
        </div>
      </section>
    </Block>
  );
};

export default NewsLetters;
